import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import AccordingToInvoiceFilter from './filter/AccordingToInvoiceFilter';
import AccordingToInvoiceTable from './table/AccordingToInvoiceTable';

export const incomeBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'analytics',
    url: '/analytics/revaluation/revaluation-invoice'
  },

  {
    label: 'revaluation_products',
    url: '/analytics/revaluation/revaluation-invoice'
  },

  {
    label: 'revaluation_invoice',
    active: true
  }
];

const AccordingToInvoice = () => {
  const { t } = useTranslation();

  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [optionSenderId, setOptionSenderId] = useState('');
  const [optionWarehouseId, setOptionWarehouseId] = useState('');
  const [barnchId, setBranchId] = useState('');

  return (
    <div>
      <PageBreadcrumb items={incomeBreadcrumbItems} />
      <div>
        <h2 className="mb-5">{t('revaluation_invoice')}</h2>

        <AccordingToInvoiceFilter
          dateFrom={dateFrom}
          dateTo={dateTo}
          setDateFrom={setDateFrom}
          setDateTo={setDateTo}
          setOptionSenderId={setOptionSenderId}
          setOptionWarehouseId={setOptionWarehouseId}
          setBranchId={setBranchId}
          barnchId={barnchId}
        />
        <AccordingToInvoiceTable
          dateFrom={dateFrom}
          dateTo={dateTo}
          optionSenderId={optionSenderId}
          optionWarehouseId={optionWarehouseId}
          barnchId={barnchId}
        />
      </div>
    </div>
  );
};

export default AccordingToInvoice;
